import { render, staticRenderFns } from "./BussinessAccounts.vue?vue&type=template&id=af156ee0&scoped=true"
import script from "./BussinessAccounts.vue?vue&type=script&lang=js"
export * from "./BussinessAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af156ee0",
  null
  
)

export default component.exports